<template>
  <main>
    <!--  Phần lọc  -->
    <section>
      <el-row type="flex" :gutter="4">

        <el-col :span="3">
          <el-select
              style="width: 100%"
              filterable
              clearable
              v-model="dataFilter.type"
              placeholder="Chọn chức năng"
              @change="findAllOneKidsConfig()"
          >
            <el-option
                v-for="item in configTypeList"
                :key="item.id"
                :value="item.value"
                :label="item.label"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input
              @clear="findAllOneKidsConfig"
              clearable
              style="width: 100%"
              placeholder="Nhập tên cấu hình"
              v-model="dataFilter.configName"
              @keyup.enter.native="findAllOneKidsConfig"
          >
            <template #append>
              <el-button
                  icon="el-icon-search"
                  @click="findAllOneKidsConfig"
              ></el-button>
            </template>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input
              @clear="findAllOneKidsConfig"
              clearable
              style="width: 100%"
              placeholder="Nhập tên biến"
              v-model="dataFilter.variableName"
              @keyup.enter.native="findAllOneKidsConfig"
          >
            <template #append>
              <el-button
                  icon="el-icon-search"
                  @click="findAllOneKidsConfig"
              ></el-button>
            </template>
          </el-input>
        </el-col>
      </el-row>
    </section>

    <!--  Danh sách bảng  -->
    <section style="margin-top: 20px">
      <el-table
          ref="multipleTable"
          :empty-text="tableEmpty"
          v-loading="loading.table"
          :element-loading-text="tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255, 0)"
          highlight-current-row
          :data="dataTable"
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChange"
          :max-height="tableMaxHeight"
          border
      >
        <el-table-column
            fixed
            type="index"
            label="STT"
            width="50"
            align="center"
        >

        </el-table-column>

        <!--        <el-table-column-->
        <!--            fixed-->
        <!--            label="ID"-->
        <!--            prop="idConfig"-->
        <!--            width="300"-->
        <!--        >-->
        <!--        </el-table-column>-->
        <el-table-column
            fixed
            label="Tên cấu hình"
            width="300"
            prop="configName"
        >
        </el-table-column>
        <el-table-column
            fixed
            label="Tên biến"
            width="300"
            prop="variableName"
        >
        </el-table-column>
        <el-table-column
            fixed
            label="Chức năng"
            width="300"
            prop="type"
        >
        </el-table-column>
        <el-table-column
            label="Mô tả"
            width="500"
            prop="description"
        >
        </el-table-column>
        <el-table-column
            align="center"
            label="Kiểu dữ liệu"
            width="200"
            prop="dataType"
        >
        </el-table-column>
        <el-table-column
            align="center"
            label="Giá trị"
            width="200"
            prop="value"
        >
        </el-table-column>
        <el-table-column
            fixed="right"
            label="Tác vụ"
            width="140"
            align="center"
        >
          <template v-slot:default="scope">
            <el-button
                size="mini"
                type="success"
                @click="updateOneKidsConfig(scope.row)"
            >Sửa
            </el-button
            >
            <el-button
                size="mini"
                type="danger"
                @click="deleteOneKidsConfig(scope.row)"
            >Xóa
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!--  Phân trang & tác vụ  -->
    <section style="margin-top: 20px">
      <el-row type="flex" :gutter="4">
        <el-col :span="22">
          <div class="container_nav_page">
            <el-pagination
                background
                layout="prev, pager, next, sizes"
                @size-change="handleSizeChange"
                @current-change="handleCurrentPageChange"
                :current-page.sync="dataFilter.page"
                :page-sizes="pageListDefaultNewOneAdmin"
                :total="totalRecords">
            </el-pagination>
          </div>
        </el-col>

        <el-col :span="2">
          <div style="float: right; margin: 15px 0">
            <el-dropdown @command="handleCommand">
              <el-button class="button-bottom" type="success">
                Tác vụ
                <i class="el-icon-caret-bottom"/>
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item command="addConfig"
                >Thêm cấu hình
                </el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>
    </section>
    <AddOneKidsConfigDialog
        :isAddOneKidsConfigDialog="isAddOneKidsConfigDialog"
        @close="handleCloseAddOneKidsConfigDialog"
    />
    <UpdateOneKidsConfigDialog
        :isUpdateOneKidsConfigDialog="isUpdateOneKidsConfigDialog"
        @close="handleCloseUpdateOneKidsConfigDialog"
        ref="UpdateOneKidsConfigDialog"
    />
  </main>
</template>

<script>
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import oneKidsConfigService from "@/services/AdminService/OneKidsConfigService";
import AddOneKidsConfigDialog from "@/views/master/systemconfig/AddOneKidsConfigDialog.vue";
import UpdateOneKidsConfigDialog from "@/views/master/systemconfig/UpdateOneKidsConfigDialog.vue";

export default {
  components: {UpdateOneKidsConfigDialog, AddOneKidsConfigDialog},
  data() {
    return {
      idListDevice: [],
      dataTable: [],
      dataFilter: {
        type: "",
        configName: "",
        variableName: "",
        page: 1,
        limit: 25,
      },
      configTypeList: [
        {id: 1, value: "CHAT", label: "OneChat"},
        {id: 2, value: "HOME", label: "Màn home"},
        {id: 3, value: "ALBUM", label: "Album"},
        {id: 4, value: "RECOGNITION", label: "Nhận diện AI"},
        {id: 5, value: "ONLINE_PAYMENT", label: "Thanh toán trực tuyến"},
        {id: 6, value: "OTHER", label: "Khác"},
      ],
      isAddOneKidsConfigDialog: false,
      isUpdateOneKidsConfigDialog: false,
      loading: {
        table: false,
      },
      totalRecords: 0,
    }
  },
  created() {
    this.findAllOneKidsConfig();
  },

  computed: {
    pageListDefaultNewOneAdmin() {
      return this.$pageListDefaultNewOneAdmin;
    },

    tableLoading() {
      return this.$tableLoading;
    },

    tableMaxHeight() {
      return this.$tableMaxHeight || 600
    },

    tableEmpty() {
      return this.$tableEmpty
    }
  },

  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff; font-weight: bold;";
    },
    async findAllOneKidsConfig() {
      await oneKidsConfigService.getConfigsByFilters(this.dataFilter.type, this.dataFilter.configName, this.dataFilter.variableName, this.dataFilter.page, this.dataFilter.limit).then((response) => {
        this.dataTable = response.data.data.data;
        this.totalRecords = response.data.data.total;
      })
    },
    handleCommand(command) {
      if (command === "addConfig") {
        this.handleOpenAddOneKidsConfigDialog()
      }
    },
    handleOpenAddOneKidsConfigDialog() {
      this.isAddOneKidsConfigDialog = true
    },
    handleCloseAddOneKidsConfigDialog() {
      this.isAddOneKidsConfigDialog = false
      this.findAllOneKidsConfig()
    },
    updateOneKidsConfig(row) {
      this.isUpdateOneKidsConfigDialog = true;
      this.$refs.UpdateOneKidsConfigDialog.getData(row)
    },
    handleCloseUpdateOneKidsConfigDialog() {
      this.isUpdateOneKidsConfigDialog = false
      this.findAllOneKidsConfig()
    },
    handleSelectionChange(value) {
      console.log(value);
    },

    handleCurrentPageChange(value) {
      this.dataFilter.page = value;
      this.findAllOneKidsConfig();
    },

    handleSizeChange(value) {
      this.dataFilter.limit = value;
      this.findAllOneKidsConfig();
    },


    deleteOneKidsConfig(row) {
      this.$confirm(
          "Bạn có chắc chắn muốn xóa hoạt đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(() => {
        oneKidsConfigService.deleteOneKidsConfig(row.idConfig).then((response) => {
          if (response.data.status === 200) {
            if (response.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Xóa cấu hình thành công!")
            } else {
              NotifyMessage.leftCornerNotificationSuccess("Xóa cấu hình thất bại!")
            }
          } else {
            NotifyMessage.leftCornerNotificationSuccess("Xóa cấu hình thất bại!")
          }
          this.findAllOneKidsConfig()
        })
      })

    }
  }
}
</script>

<style lang="scss" scoped>
.menu_task_form {
  display: contents;
  //background-color: transparent !important;
  //display: flex;
  //justify-content: end;
  //align-content: center;
}

.container_task {
  display: flex;
  justify-content: right;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}

.sub_menu {
  /deep/ .el-submenu__title {
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 4px;
  }

  /deep/ i {
    color: #FFFFFF;
    margin-top: 0 !important;
  }
}

.name_device {
  cursor: pointer;

  &:hover {
    color: #00a1ff;
  }
}
</style>